import { render, staticRenderFns } from "./SquareWithIcon.vue?vue&type=template&id=67849683"
import script from "./SquareWithIcon.vue?vue&type=script&lang=js"
export * from "./SquareWithIcon.vue?vue&type=script&lang=js"
import style0 from "./SquareWithIcon.vue?vue&type=style&index=0&id=67849683&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-tree-view/vuestic-div-checkbox/SquareWithIcon.vue
// module id = eOeK
// module chunks = 41